import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "content"];

  connect() {
    this.popoverVisible = false;
  }

  toggle(event) {
    event.stopPropagation()
    this.popoverVisible = !this.popoverVisible;

    // Support both menu and content targets
    const target = this.hasMenuTarget ? this.menuTarget : this.contentTarget;
    if (target) {
      if (this.popoverVisible) {
        target.classList.remove("hidden");
      } else {
        target.classList.add("hidden");
      }
    }
  }

  hide(event) {
    // Don't hide if clicking inside the dropdown
    if (this.element.contains(event.target)) {
      return;
    }

    this.popoverVisible = false;
    const target = this.hasMenuTarget ? this.menuTarget : this.contentTarget;
    if (target) {
      target.classList.add("hidden");
    }
  }
}
